import checkoutDataNotLoggedHtml from './checkoutdatanotlogged.component.html';
import './checkoutdatanotlogged.component.scss';

class CheckoutDataNotLoggedController {
    constructor($scope, $window, CheckoutService, $sce) {
        'ngInject';
        this.$scope = $scope;
        this.service = CheckoutService;
        this.$sce = $sce;
        this.form = null;
        this.emailConfirmationPattern = null;
    }

    $onInit() {
        this.service.step = 2;

        this.$scope.$watch(() => this.form, (n, o) => {
            this.service.setUserDataForm(this.form);
        });

        // Copy an invoice data to the shipping data
        this.$scope.$watch(() => this.service.data.invoiceAddress, (newVal, oldVal) => {
            if (newVal.invoice !== oldVal.invoice && newVal.invoice === '0') {
                this.service.data.invoiceAddress.taxNumber = '';
            }

            for (const [key, value] of Object.entries(newVal)) {
                if (key === 'email' || value === oldVal[key]) {
                    continue;
                }

                const shippingAddressInputName = 'shipmentAddress' + key.charAt(0).toUpperCase() + key.slice(1);
                if (this.form && this.form[shippingAddressInputName] && this.form[shippingAddressInputName].$touched || this.service.shippingAddressAutofilled) {
                    continue;
                }

                this.service.data.shipmentAddress[key] = value;
            }
        }, true);

        this.$scope.$watch(() => this.service.taxIdOmit, (newVal, oldVal) => {
            if (newVal === true) {
                this.service.data.invoiceAddress.taxNumber = null;
            }
        });

        this.$scope.$watch(() => this.service.data.invoiceAddress.invoice, (newVal, oldVal) => {
            if (newVal === '0') {
                this.service.data.invoiceAddress.taxNumber = null;
            }
        });

        this.$scope.$watch(() => this.service.data.invoiceAddress.country, (newVal, oldVal) => {
            if (this.$scope.$ctrl.form) {
                for (let $$control of this.$scope.$ctrl.form.$$controls) {
                    console.log($$control.$name);
                    if ($$control.$name === 'invoiceTaxNumber') {
                        $$control.$setDirty();
                        $$control.$validate();
                    }
                }
            }
        }, true);

        this.$scope.taxNumberPattern = (() => {
            let patterns = {
                4: [/^(CZ\d{8,10})?$/, /^[A-Z]{2}\d{5,18}$/],
                5: /^(ATU)?[0-9]{8}$/
            };

            return {
                test: (value) => {
                    if (patterns[this.service.shopId]) {
                        switch(this.service.shopId) {
                            case 4: // CZ
                                if (this.service.data.invoiceAddress.country === 'CZ') {
                                    return patterns[this.service.shopId][0].test(value);
                                }

                                return patterns[this.service.shopId][1].test(value);
                            case 5: // AT
                                if (this.service.data.invoiceAddress.country === 'AT') {
                                    return patterns[this.service.shopId].test(value);
                                }

                                return true;
                        }
                    } else {
                        return true;
                    }
                }
            };
        })();

        this.$scope.$watch(() => this.service.data.invoiceAddress.email, (newVal, oldVal) => {
            if (newVal) {
                this.emailConfirmationPattern = new RegExp('^' + newVal + '$');
            }
        });
    }

    hasErrors(formPart) {

        for (const [key, value] of Object.entries(this.form)) {
            if (!key.startsWith(formPart)) {
                continue;
            }

            if (!value.$valid && (this.form.$submitted || value.$touched)) {
                return true;
            }
        }

        return false;
    }

    getAddressPattern() {
        return '^(?=.*[A-Za-z])(?=.*\\d).+$';
    }

    getEmailConfirmationPattern() {
        return this.emailConfirmationPattern;
    }

    test() {
        this.form.$$setSubmitted();
    }
}

let checkoutDataNotLoggedComponent = {
    bindings: {},
    template: checkoutDataNotLoggedHtml,
    controller: CheckoutDataNotLoggedController
}

export default checkoutDataNotLoggedComponent;
